import { Box } from "@mui/material";
import { UBButton } from "../../../Libraries";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { PlusBlueIcon } from "../../../assets/icons/icon";
import AddQuickItem from "./AddQuickItem";
import { camelCase, sentenceCase } from "../../../constants";

const StockAddItem = ({
  handleAddItem,
  updateAmountWithTotal,
  itemObj,
  isITook,
  handleStartLogEvent = () => {},
  id = "",
  isDisplayUpdateAmountSection = true,
  required = false,
}) => {
  const [I18n] = useContext(LanguageContext);
  return (
    <AddQuickItem
      handleAddItem={handleAddItem}
      updateAmountWithTotal={updateAmountWithTotal}
      itemObj={itemObj}
      isITook={isITook}
      id={id}
      isDisplayUpdateAmountSection={isDisplayUpdateAmountSection}
      required={required}
    />
  );
};

export default StockAddItem;
